

import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Footer() {

  // State to hold footer data and any potential errors
  const [footerdata, setFooterData] = useState();
  const [err, setErr] = useState();

  // Fetch footer data on component mount
  useEffect(() => {
    const fetchdata = async () => {
      try {
        // Make API call to get footer data
        const response = await axios.get('https://admin.techno-elevators.com/api/geFooterData');
        setFooterData(response.data.data); // Set the fetched data to state
      } catch (err) {
        setErr(err); // If there's an error, store it in the error state
      }
    };
    fetchdata();
  }, []); // Empty dependency array ensures it runs only once when the component mounts

  return (
    <>
      <div className="footer_section layout_padding" style={{ display: 'flex', justifyContent: 'center' }}>
        <Container>
          <div className="footer_section_2">
            <Row>
              {/* Useful Links Section */}
              <Col lg={3} sm={6}>
                <h6 className="link_text">Useful link</h6>
                <div className="footer_menu social_icon">
                  {/* Loop through the first footer section items */}
                  {footerdata?.fisrt_footer_section.map((item, index) => (
                    <p key={index} className='footer_text_2'>
                      <a href={item.slug}>{item.menu_name_en}</a>
                    </p>
                  ))}
                </div>
              </Col>

              {/* Solutions Section */}
              <Col lg={3} sm={6} className='footer-links'>
                <h6 className="link_text">SOLUTIONS</h6>
                {/* Loop through the second footer section items */}
                {footerdata?.second_footer_section.map((item, index) => (
                  <p key={index} className="footer_text_2" style={{ marginBottom: '0' }}>
                    <a href={item.menu_name_en === "Products" ? item.link : item.slug} style={{ color: "black" }}>
                      {item.menu_name_en}
                    </a>
                  </p>
                ))}
              </Col>

              {/* Social Media Section */}
              <Col lg={3} sm={6}>
                <h6 className="link_text">social media</h6>
                <div className="social_icon">


                  <a href="https://www.facebook.com/profile.php?id=61571251670387" style={{ paddingRight: '8px' }}><img src="https://themewagon.github.io/Heado/images/fb-icon.png" alt="Facebook Icon" /></a>
                  {/* <a href="#" style={{paddingRight:'8px'}}><img src="https://themewagon.github.io/Heado/images/twitter-icon.png" alt="Twitter Icon"/></a> */}
                  {/* <a href="#" style={{ paddingRight: '8px' }}><img src="https://themewagon.github.io/Heado/images/linkedin-icon.png" alt="LinkedIn Icon" /></a> */}
                  {/* <a href="#" style={{ paddingRight: '8px' }} ><img src="https://themewagon.github.io/Heado/images/youtub-icon.png" alt="YouTube Icon" /></a> */}
                  <a href="https://www.instagram.com/technoelevatorsoman/" ><img style={{ borderRadius: '15px' }} src="Images/social-media-icons/instagram.png" alt="Instagram" height={35} /></a>


                </div>
              </Col>

              {/* Get In Touch Section */}
              <Col lg={3}>
                <h6 className="link_text">Get In Touch</h6>
                <div className="social_icon">
                  <p className="footer_text_1">
                    PO Box 253, Muscat-188,<br />
                    Sultanate Of Oman<br />
                    <p className="footer-p-tag">info.oman@techno-elevators.com</p>
                    <p className="footer-p-tag">Landline: +968 22527900</p>
                    <p className="footer-p-tag">Sales: +968 91393423</p>
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
}

export default Footer;

